import _ from "lodash";
import { DefaultAvailabilityFilter } from "src/components/base/TimePicker/TimePicker";

function getSearchCADataFilter(
    searchUpdatedFilter: any,
    searchCAData: any,
    selectedTherapist: any
): any {
    if (
        !_.isEmpty(searchUpdatedFilter) &&
        !_.isEqual(searchUpdatedFilter, searchCAData?.filter)
    ) {
        const finalUpdate = [...searchUpdatedFilter];

        if (
            searchUpdatedFilter.length > 0 &&
            (selectedTherapist === "" ||
                selectedTherapist === undefined ||
                selectedTherapist === null)
        ) {
            return {
                ...searchCAData,
                filters: [...finalUpdate],
                therapist_ids: [],
            };
        } else {
            return {
                ...searchCAData,
                filters: [...finalUpdate],
            };
        }
    }
}

function getScheduleFilter(
    scheduleFilterObject: any,
    selectedTherapist: any,
    scheduleFilter: any
): any {
    const selectedData: any[] = [];

    scheduleFilter?.selectedValue?.forEach((choice: any) => {
        selectedData.push(choice.unique_key);
    });

    if (scheduleFilter?.filter?.filter_key === "meetingPreference") {
        return {
            ...scheduleFilterObject,
            therapist_ids:
                selectedTherapist && selectedTherapist !== ""
                    ? [selectedTherapist]
                    : [],
            meeting_pref: selectedData,
        };
    }

    if (scheduleFilter?.filter?.filter_key === "serviceType") {
        return {
            ...scheduleFilterObject,
            therapist_ids:
                selectedTherapist && selectedTherapist !== ""
                    ? [selectedTherapist]
                    : [],
            service_type: selectedData?.length ? selectedData[0] : "",
        };
    }
}

function getAvailibilityFilter(scheduleFilterObject: any, filters: any): any {
    return {
        ...scheduleFilterObject,
        schedule_day:
            filters?.weekDaysFilter || DefaultAvailabilityFilter.weekDaysFilter,
        time_from:
            filters?.timeFrom || DefaultAvailabilityFilter.timeFrom || null,
        time_until: filters?.timeTo || DefaultAvailabilityFilter.timeTo || null,
        callAPI: true,
    };
}

export { getSearchCADataFilter, getScheduleFilter, getAvailibilityFilter };
